import { getCurrentMedio } from "../../utils/medioTags";

const HeaderGoldenball = ({info, isSpecialVote})=>{
    return(
        <>
       {isSpecialVote && (<p className='golden-ball-voted-screen-subcontainer-subttle-special-Nominate' >Bienvenido estimado <span >{getCurrentMedio(info, isSpecialVote)?.name}</span> para nosostros es importante su voto, ya que es una figura muy importante en el futbol de la talacha </p>)}
         <div className='golden-ball-voted-screen-subcontainer-title-golden-edition' >
          <p >{`${info?.name} ${info?.year}`}</p>
        </div>
        </>


    )
}

export default HeaderGoldenball;